import { BroadcastChannel } from 'broadcast-channel';

export const VKHandler = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code');
  const chanel = new BroadcastChannel('auth-vk-code');

  if (code) {
    chanel.postMessage({
      code,
      success: true,
    });
  } else {
    const error = {};
    searchParams.forEach((value, key) => {
      error[key] = value;
    });
    chanel.postMessage({
      success: false,
      error,
    });
  }
  setTimeout(() => {
    window.close();
  }, 250);
};
